export default {
  apiKey: 'AIzaSyCNamsKSXXw7VGqzn9pCZ3cIqzZ2jOnm1Y',
  authDomain: 'euanrigganscom.firebaseapp.com',
  databaseURL: 'https://euanrigganscom.firebaseio.com',
  projectId: 'euanrigganscom',
  storageBucket: 'euanrigganscom.appspot.com',
  messagingSenderId: '965617264823',
  appId: '1:965617264823:web:bc459807b6d81bd1'
}
